import React from 'react';

interface Props {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export default function TableRow({ children, onClick, className = '' }: Props): JSX.Element {
  return (
    <tr className={`app-table__row ${className}`} onClick={onClick}>
      {children}
    </tr>
  );
}
